import { render, staticRenderFns } from "./TopicCard--OLD.vue?vue&type=template&id=e1ce152e&"
import script from "./TopicCard--OLD.vue?vue&type=script&lang=js&"
export * from "./TopicCard--OLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports